import React from 'react';
import { KPICard, LoadingSpinner } from '../../ui';
import { formatNumber } from '../../../utils/formatters';
import { 
  useRefineCustomerSurveyCount, 
  useRefineCustomerTotalResponses 
} from '../../../hooks/useRefineCustomerQueries';

import { KPIProps } from '../../../types/kpi';
const SurveyFormsKPI: React.FC<KPIProps> = ({
  branchId = 0,
  onError,
  showLoading = true,
  compact = false,
  className = ''
}) => {
  const { data: totalSurveyForms, isLoading: isLoadingSurvey, error: surveyError, refetch: refetchSurvey } = useRefineCustomerSurveyCount(branchId);
  const { data: totalResponses, isLoading: isLoadingResponses, error: responsesError } = useRefineCustomerTotalResponses(branchId);

  const isLoading = isLoadingSurvey || isLoadingResponses;
  const error = surveyError || responsesError;

  React.useEffect(() => {
    if (error && onError) {
      onError(error as Error);
    }
  }, [error, onError]);

  if (isLoading && showLoading) {
    return (
      <div className={`${className} animate-enter animate-delay-3`}>
        <div className="card-base card-padding">
          <div className="flex flex-col items-center justify-center h-32">
            <LoadingSpinner
              variant="minimal"
              size="md"
            />
          </div>
        </div>
      </div>
    );
  }

  if (error || (!totalSurveyForms && totalSurveyForms !== 0)) {
    return (
      <div className={`${className} card-base border border-status-error p-4`}>
        <p className="text-status-error text-sm">خطا در بارگذاری فرم‌های نظرسنجی</p>
        {showLoading && (
          <button
            onClick={() => refetchSurvey()}
            className="mt-2 text-xs text-primary-600 hover:text-primary-700"
          >
            تلاش مجدد
          </button>
        )}
      </div>
    );
  }

  return (
    <div className={`${className} animate-enter-up stagger-1`}>
      <KPICard
        title="فرم‌های نظرسنجی"
        value={formatNumber(totalSurveyForms || 0)}
        subtitle={`تعداد ${formatNumber(totalResponses || 0)} پاسخ به سوال`}
        variant="primary"
        accentStyle="corner"
      />
    </div>
  );
};

export default SurveyFormsKPI;